"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldComponentUpdate = void 0;
function shouldComponentUpdate(oldProps, nextProps) {
    var nextPropsKeys = Object.keys(nextProps);
    var currPropsKeys = Object.keys(oldProps);
    var shouldUpdate = (nextPropsKeys.length !== currPropsKeys.length || nextPropsKeys.some(function (prop) { return nextProps[prop] !== oldProps[prop]; }));
    return shouldUpdate;
}
exports.shouldComponentUpdate = shouldComponentUpdate;
//# sourceMappingURL=ShouldComponentUpdate.js.map